module.exports = __webpack_public_path__ + "static/media/Line.d3c23cfb.svg";